import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';

export const ResultPanelStyle = styled.div`
  background: ${(prop) => prop.theme.background.surface}; 
  padding: 15px;
  z-index: 0;
  position: absolute;
  height: 99.5%;
  overflow-y: hidden;
  overflow-x: hidden;
  width: 33rem;
  display: flex;
  flex-direction: column; 
  right: 0;
`

export const ResultHeader= styled.div`
  display: flex;
  height: 40px;
  margin-left: 0.5rem;
  margin-bottom: 10px;
  .crossIcon {
    margin-left:auto;
    cursor: pointer;
    height:25px;
    width:25px;
  }  
`;

export const ResultRowContainer = styled.div`
  display: flex;
  color: white;
  height:18px;
  flex-direction: row;
  flex-wrap: no wrap;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 10px;
`;


export const ResultText = styled.div`
  width: 160px;
  height:18px;
  display: flex;  
`;
export const ResultText2 = styled.div` 
  height:15px;
  display: flex;
  margin-top: 1px;
  margin-left: 1px;
  align-items: left;
`;

export const TableContainer = styled.div`
  margin: 16px;
  height: calc(100vh - 180px);
  background: ${({ theme }) => theme.background};
`;

export const TableStyled = styled(BaseTable)`
  width: 100%;
  
  th, td {
    padding: 8px 16px;
    white-space: nowrap;
    background: ${({ theme }) => theme.background};
  }

  thead tr {
    position: sticky;
    top: 0;
    z-index: 1;
    background: ${({ theme }) => theme.background};
  }
`;

export const ResultFooter = styled.div`
height: 10%;
`;